import React from 'react'

import intervalChoiceValues from '../misc/intervalChoiceValues'
import intervalChoiceUnits from '../misc/intervalChoiceUnits'
import setContactInterval from '../../actions/setContactInterval'
import unsetContactInterval from '../../actions/unsetContactInterval'
import {
  Select,
} from '../../styles/forms'
import {
  AppAction,
} from '../../styles/links'

const IntervalChanger = ({person}) => (
  <span>
    <ion-icon name="refresh" className="small"></ion-icon>
    <Select value={person && person.interval && person.interval.value} onChange={event => setContactInterval({personId: person.id, value: event.target.value})}>
      {intervalChoiceValues.map(value => (
        <option key={value} value={value}>
          {value}
        </option>
      ))}
    </Select>
    <Select value={person && person.interval && person.interval.unit} onChange={event => setContactInterval({personId: person.id, unit: event.target.value})}>
      {intervalChoiceUnits.map(unit => (
        <option key={unit.id} value={unit.id}>
          {unit.namePlural}
        </option>
      ))}
    </Select>

    <AppAction onClick={ () => unsetContactInterval(person.id)}>don't remind me</AppAction>
  </span>
)

export default IntervalChanger



// WEBPACK FOOTER //
// ./src/views/person/IntervalChanger.js